module.exports = __webpack_public_path__ + "static/map-0e26c388c4c8719a379b0ba14db3d0fc.png";